import { useNavigate } from "react-router-dom";

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <div className="w-full mx-auto px-4 md:px-10 py-16">
      <div className="max-w-5xl mx-auto rounded-[4px] p-8 md:p-12 text-center text-white bg-secondary shadow-lg transition-all duration-300 hover:shadow-2xl hover:-translate-y-1">
        {/* Headline */}
        <h2 className="text-2xl md:text-4xl font-semibold mb-4">
          Start Transforming Your Documents Today
        </h2>

        {/* Description */}
        <p className="text-sm md:text-base text-gray-100 max-w-2xl mx-auto mb-8">
          Discover how Bridge Format AIQ can turn your complex documents into
          structured insights and automated workflows.
        </p>

        {/* Button */}
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-white text-primary hover:bg-gray-100 transition-all duration-300 px-6 py-3 rounded-[4px] shadow-md font-medium"
        >
          Talk to an Expert
        </button>
      </div>
    </div>
  );
}
